export const versionInfo = {
	number: 'v3.9.9',
	date: 'May 27, 2025',
	portal: {
		newsTitle: [],
		newsContent: [],
	},
	supplier: {
		newsTitle: [],
		newsContent: [],
	},
	customer: {
		newsTitle: [],
		newsContent: [],
	},
	config: {
		newsTitle: [],
		newsContent: [],
	},
};



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/version-info.ts